import { styled } from "@material-ui/styles";
import { Column, Columns, div, XLargeButton } from "lqx-react";
import React from "react";
import { UserEntitlementCatalogs } from "src/app/models/UserEntitlements";
import { Can } from "src/app/services/can";
import { AssetType } from "../api/assetType";
import { CancelButton, WorkflowBody, WorkflowFooter, WorkflowRow, WorkflowTitle } from "../shared";

export const ChooseAssetTypeStep = ({ onAssetTypeSelected, cancel }: { onAssetTypeSelected?, cancel?}) => (
    <>
        <WorkflowTitle>
            Step 1: Please Choose an Asset Type
        </WorkflowTitle>
        <WorkflowBody>
            <WorkflowRow>
                <Columns>
                    {Can(UserEntitlementCatalogs.DigitizeInvoices) &&
                        <AssetTypeColumn>
                            <XLargeButton
                                icon="/assets/images/icon_invoices.png"
                                onClick={() => onAssetTypeSelected(AssetType.invoice)}
                                qa-id="digitize-invoices">
                                <h3>Invoices</h3>
                                <span>Digitize your invoices and supporting documents. </span>
                            </XLargeButton>
                        </AssetTypeColumn>
                    }
                    {Can(UserEntitlementCatalogs.DigitizeInsurancePolicies) &&
                        <AssetTypeColumn>
                            <XLargeButton
                                icon="/assets/images/icon_policies.png"
                                onClick={() => onAssetTypeSelected(AssetType.insurancePolicy)}
                                qa-id="upload-policy">
                                <h3>Insurance Policies</h3>
                                <span>Upload your policies and supporting policies.</span>
                            </XLargeButton>
                        </AssetTypeColumn>
                    }
                    {Can(UserEntitlementCatalogs.DigitizePayments) &&
                        <AssetTypeColumn>
                            <XLargeButton
                                icon="/assets/images/icon_payments.png"
                                onClick={() => onAssetTypeSelected(AssetType.payment)}
                                qa-id="upload-payments">
                                <h3>Payments</h3>
                                <span>Digitize your payments</span>
                            </XLargeButton>
                        </AssetTypeColumn>
                    }
                    {Can(UserEntitlementCatalogs.DigitizeCreditNotes) &&
                        <AssetTypeColumn>
                            <XLargeButton
                                icon="/assets/images/icon_creditnote.png"
                                onClick={() => onAssetTypeSelected(AssetType.creditNote)}
                                qa-id="upload-credit-notes">
                                <h3>Credit Notes</h3>
                                <span>Digitize your Credit Notes and save them</span>
                            </XLargeButton>
                        </AssetTypeColumn>
                    }
                    {Can(UserEntitlementCatalogs.DigitizeRemittanceAdvices) &&
                        <AssetTypeColumn>
                            <XLargeButtonContainer>
                                <XLargeButton
                                    icon="/assets/images/icon_remittanceadvice.png"
                                    onClick={() => onAssetTypeSelected(AssetType.remittanceAdvice)}
                                    qa-id="upload-remittance-advices">
                                    <h3>Remittance Advices</h3>
                                    <span>Digitize your Remittance Advices and save them</span>
                                </XLargeButton>
                            </XLargeButtonContainer>
                        </AssetTypeColumn>
                    }
                    {Can(UserEntitlementCatalogs.DigitizeMultiAssetFiles) &&
                        <AssetTypeColumn>
                            <XLargeButton
                                icon="/assets/images/icon_multiasset.png"
                                onClick={() => onAssetTypeSelected(AssetType.multiAsset)}
                                qa-id="upload-multi-asset">
                                <h3>Multiple Asset Types</h3>
                                <span>Digitize multiple assets from a single import file</span>
                            </XLargeButton>
                        </AssetTypeColumn>
                    }
                    {Can(UserEntitlementCatalogs.DigitizePurchaseOrders) &&
                        <AssetTypeColumn>
                            <XLargeButton
                                icon="/assets/images/icon_purchase_order.png"
                                onClick={() => onAssetTypeSelected(AssetType.purchaseOrder)}
                                qa-id="upload-purchase-order">
                                <h3>Purchase Orders</h3>
                                <span>Digitize your Purchase Orders and save them</span>
                            </XLargeButton>
                        </AssetTypeColumn>
                    }
                    {Can(UserEntitlementCatalogs.DigitizeUac) &&
                        <AssetTypeColumn>
                            <XLargeButton
                                icon="/assets/images/icon_unapplied_cash.png"
                                onClick={() => onAssetTypeSelected(AssetType.unappliedCash)}
                                qa-id="upload-unapplied-cash">
                                <h3>Unapplied Cash</h3>
                                <span>Digitize your Unapplied Cash</span>
                            </XLargeButton>
                        </AssetTypeColumn>
                    }
                    {Can(UserEntitlementCatalogs.DigitizeCustomerData) &&
                        <AssetTypeColumn>
                            <XLargeButton
                                icon="/assets/images/icon_customer_reference_data.png"
                                onClick={() => onAssetTypeSelected(AssetType.customerReferenceData)}
                                qa-id="upload-customer-reference-data">
                                <h3>Customer Reference Data</h3>
                                <span>Digitize your Customer Reference Data</span>
                            </XLargeButton>
                        </AssetTypeColumn>
                    }
                </Columns>
            </WorkflowRow>
        </WorkflowBody>
    </>
);

export const AssetTypeColumn = styled(Column)({
    maxWidth: '600px',
    minWidth: '600px',
    width: '600px',
    marginTop: '25px'
});

export const XLargeButtonContainer = div({
    '& span.MuiIconButton-label div': {
        width: '100% !important'
    }
});
